import { useRef, useState } from 'react';

const PM_COORD_BASE = import.meta.env.VITE_PM_COORD_URL ?? 'https://pm-coord.pagemind.ai';
const PM_COORD_CHAT_URL = `${PM_COORD_BASE}/app/council/chat`;
const PM_COORD_BUS_URL = `${PM_COORD_BASE}/app`;

export default function ChatPage() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [embedFailed, setEmbedFailed] = useState(false);

  if (embedFailed) {
    return (
      <div className="h-full -m-6" style={{ height: 'calc(100vh - 64px)' }}>
        <div className="flex flex-col items-center justify-center h-full gap-4 text-center p-8">
          <p className="text-muted-foreground text-sm">
            The council chat could not be embedded (X-Frame-Options or CSP). Open it directly:
          </p>
          <a
            href={PM_COORD_CHAT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90"
          >
            Open Council Chat ↗
          </a>
          <p className="text-xs text-muted-foreground">
            Not signed in?{' '}
            <a href={PM_COORD_BUS_URL} target="_blank" rel="noopener noreferrer" className="underline">
              Sign in at pm-coord Bus first
            </a>
            , then reload.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full -m-6" style={{ height: 'calc(100vh - 64px)' }}>
      <div className="bg-background border-b px-6 py-3 flex items-center justify-between">
        <h2 className="text-lg font-semibold">Council Chat</h2>
        <div className="flex items-center gap-3">
          <a
            href={PM_COORD_BUS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-muted-foreground hover:text-foreground"
          >
            pm-coord Bus ↗
          </a>
          <a
            href={PM_COORD_CHAT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-muted-foreground hover:text-foreground"
          >
            Open in new tab ↗
          </a>
        </div>
      </div>
      <iframe
        ref={iframeRef}
        src={PM_COORD_CHAT_URL}
        title="Council Chat"
        className="w-full border-0"
        style={{ height: 'calc(100% - 52px)' }}
        allow="clipboard-write"
        onError={() => setEmbedFailed(true)}
      />
    </div>
  );
}
